SE.clsPopup = (function() {
  //INIT
  function init(){
    initEvent();
  
  }

  function initEvent()
  {
    openPopup();
  }

  //FUNCTIONS
  function openPopup() {
    
    $('.dropdown-item').click(function() {
      var popup = $(this).attr('id');
      
      $("#popup-" + popup).show();
      console.log();
      closePopup(popup);
    })
  }

  function closePopup(id) {
    $('.xclose').click(function(){
      $("#popup-" + id).hide();
    })
  }

  //RETURN
  return {
    init:init,
  }
})();
SE.clsPopup.init();

